const e = "input", s = {
  "responsive-table": "responsive-table",
  "responsive-table__table": "responsive-table__table",
  "responsive-table__caption": "responsive-table__caption",
  "responsive-table__header-row": "responsive-table__header-row",
  "responsive-table__header-item": "responsive-table__header-item",
  "responsive-table__body-item": "responsive-table__body-item",
  "responsive-table__cell-html": "responsive-table__cell-html",
  "responsive-table__body-row": "responsive-table__body-row",
  "responsive-table__no-results": "responsive-table__no-results",
  "responsive-table__no-results-icon": "responsive-table__no-results-icon",
  "responsive-table--sticky-header": "responsive-table--sticky-header",
  "responsive-table--alternated-rows": "responsive-table--alternated-rows",
  "responsive-table--alternated-columns": "responsive-table--alternated-columns",
  "responsive-table--alternated-row-single": "responsive-table--alternated-row-single",
  "responsive-table--alternated-column-single": "responsive-table--alternated-column-single",
  "responsive-table--sortable": "responsive-table--sortable",
  "responsive-table__header-item--sortable": "responsive-table__header-item--sortable",
  "responsive-table__sort-icon": "responsive-table__sort-icon",
  "responsive-table--align-text-right": "responsive-table--align-text-right",
  "responsive-table__table--is-small": "responsive-table__table--is-small",
  "responsive-table__header": "responsive-table__header",
  "responsive-table__filter": "responsive-table__filter",
  input: e
};
export {
  s as default,
  e as input
};
